import { render } from "./Bottom_Nav.vue?vue&type=template&id=4de056d0&scoped=true"
import script from "./Bottom_Nav.vue?vue&type=script&lang=js"
export * from "./Bottom_Nav.vue?vue&type=script&lang=js"

import "./Bottom_Nav.vue?vue&type=style&index=0&id=4de056d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de056d0"]])

export default __exports__